const transactionCountReport = {
  transaction_count_report: "Transaction Count Report",
  all_accounts: "All accounts",
  account: "Account",
  year: "Year",
  month: "Month",
  period: "Period",
  bank: "Bank",
  iban: "IBAN",
  account_name: "Account name",
  total_credit_transactions: "Total credit transactions",
  total_debit_transactions: "Total debit transactions",
  total_transactions: "Total transactions",
  report_range_exceeds_6_months:
    "The selected range cannot exceed 6 calendar months. Please adjust the dates.",
  no_data_available: "No data available",
  export_csv: "Export CSV",
  start_date: "Start date",
  end_date: "End date",
  start_date_required: "Start date is required",
  end_date_required: "End date is required",
  end_date_before_start_date: "End date cannot be before start date",
  filter_by: "Filter by",
  search: "Search",
};

export default transactionCountReport;
